  import { CapteursService, Capteur } from '../../../services/capteurs.service';
  import { CapteurModaleComponent } from '../../../components/capteur_modale/capteur_modale.component';
  
 


import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';


 
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommandesService, Commande, CommandePayload, LigneCommande } from '../../../services/commandes.service';
import { TypeCapteursService, TypeCapteur } from '../../../services/type-capteurs.service';
import { CartouchesService, Cartouche } from '../../../services/cartouches.service';
import { Chimie, ChimieService } from '../../../services/chimie.service';
import { ClientsService, Client } from '../../../services/clients.service';
import { AdressesService, Adresse } from '../../../services/adresses.service';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatOptionModule } from '@angular/material/core';
import { MatLabel } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';

type LigneCommandeEdit = Omit<LigneCommande, 'cartouche_a' | 'cartouche_b'> & {
  cartouche_a?: number | null;
  cartouche_b?: number | null;
  cartoucheAInput?: string;
  cartoucheBInput?: string;
};

@Component({
  selector: 'app-commandes-edit',
  templateUrl: './commandes-edit.component.html',
  styleUrls: ['./commandes-edit.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatOptionModule,
    MatAutocompleteModule,
    CapteurModaleComponent
  ]
})
export class CommandesEditComponent implements OnInit {
  capteurModaleVisible = false;
  capteurModaleData: Capteur | null = null;
  commandeId!: number;
  commande!: Commande;
  loading = true;
  saving = false;
  statutsCommande = [
    { value: 'en cours', label: 'En cours' },
    { value: 'soldée', label: 'Soldée' },
    { value: 'annulée', label: 'Annulée' }
  ];
  lignesCommande: LigneCommandeEdit[] = [];
  nouvelleLigne: any = { type_capteur: '', adresse_livraison_id: null, cartouche_a: null, cartouche_b: null, date_expedition: '' };
  editingLigneId: number | null = null;
  adressesLivraisonClient: Adresse[] = [];
  typeCapteurs: TypeCapteur[] = [];
  cartoucheAOptions: Cartouche[] = [];
  cartoucheBOptions: Cartouche[] = [];
  cartoucheAInput = '';
  cartoucheBInput = '';
  error = '';
  cartouches: Cartouche[] = [];
  chimies: Chimie[] = [];
  success = '';
  ligneSuccess = '';

  clients: Client[] = [];
  commandesList: Commande[] = [];

  constructor(
    private route: ActivatedRoute,
    private commandesService: CommandesService,
    private typeCapteursService: TypeCapteursService,
    private cartouchesService: CartouchesService,
    private chimieService: ChimieService,
    private clientsService: ClientsService,
    private adressesService: AdressesService,
    private capteursService: CapteursService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.loadClients();
  }

  openCapteurModale(ligne_commande_id: number) {
    this.capteurModaleVisible = true;
    this.capteurModaleData = null;
    this.capteursService
      .getByLigneCommande(ligne_commande_id)
      .subscribe({
        next: (capteur) => {
          this.capteurModaleData = capteur;
          this.cdr.detectChanges();
        },
        error: () => {
          this.capteurModaleData = null;
          this.capteurModaleVisible = false;
          this.cdr.detectChanges();
        },
      });
  }

  closeCapteurModale() {
    this.capteurModaleVisible = false;
    this.capteurModaleData = null;
    this.cdr.detectChanges();
  }

  loadClients() {
    this.clientsService.list().subscribe(clients => {
      this.clients = clients;
      this.cdr.detectChanges();
    });
  }

  onCartoucheASelected(event: any) {
    const selected = this.cartoucheAOptions.find(c => c.nom === event.option.value);
    if (selected) {
      this.nouvelleLigne.cartouche_a = selected.id;
      this.cartoucheAInput = selected.nom ?? '';
    }
  }

    // Initialise les inputs d'autocomplete pour chaque ligne lors du chargement
  private setCartoucheInputsOnLignes() {
    for (const ligne of this.lignesCommande) {
      if (ligne.cartouche_a) {
        this.cartouchesService.getNom(ligne.cartouche_a).subscribe({
          next: (res) => {
            ligne.cartoucheAInput = res.nom;
            this.cdr.detectChanges();
          },
          error: () => {
            ligne.cartoucheAInput = '';
            this.cdr.detectChanges();
          }
        });
      } else {
        ligne.cartoucheAInput = '';
      }
      if (ligne.cartouche_b) {
        this.cartouchesService.getNom(ligne.cartouche_b).subscribe({
          next: (res) => {
            ligne.cartoucheBInput = res.nom;
            this.cdr.detectChanges();
          },
          error: () => {
            ligne.cartoucheBInput = '';
            this.cdr.detectChanges();
          }
        });
      } else {
        ligne.cartoucheBInput = '';
      }
    }
  }

  
  onCartoucheBSelected(event: any) {
    const selected = this.cartoucheBOptions.find(c => c.nom === event.option.value);
    if (selected) {
      this.nouvelleLigne.cartouche_b = selected.id;
      this.cartoucheBInput = selected.nom ?? '';
    }
  }



    
  ngOnInit() {
    this.typeCapteursService.list().subscribe(types => this.typeCapteurs = types);
    this.chimieService.list().subscribe(chimies => {
      this.chimies = chimies;
      this.cdr.detectChanges();
    });
    this.cartouchesService.list().subscribe(cartouches => {
      this.cartouches = (cartouches ?? []).filter(c => c.utilise !== true && c.inutilisable !== true);
      this.cdr.detectChanges();
    });
    this.commandesService.list().subscribe(list => {
      this.commandesList = list;
      this.loading = false;
      this.cdr.detectChanges();
    });
    this.route.paramMap.subscribe(params => {
      const idParam = params.get('id');
      this.commandeId = idParam ? +idParam : 0;
      if (this.commandeId) {
        this.loadCommandeById(this.commandeId);
      } else {
        this.commande = undefined as any;
        this.lignesCommande = [];
        this.cdr.detectChanges();
      }
    });
  }



  selectCommande(id: number) {
    if (id && id !== this.commandeId) {
      this.commandeId = id;
      this.loadCommandeById(id);
    } else if (!id) {
      this.commandeId = 0;
      this.commande = undefined as any;
      this.lignesCommande = [];
      this.cdr.detectChanges();
    }
  }

  loadCommandeById(id: number) {
    this.loading = true;
    this.commandesService.get(id).subscribe(cmd => {
      this.commande = { ...cmd };
      this.loadAdressesLivraisonClient(this.commande.client_id);
      this.loading = false;
      this.loadLignes();
      this.cdr.detectChanges();
    });
  }

  loadAdressesLivraisonClient(clientId: number) {
    this.adressesService.list().subscribe(adresses => {
      this.adressesLivraisonClient = adresses.filter(
        a => a.client_id === clientId && String(a.type_adresse ?? '').trim().toLowerCase().replace(/_/g, ' ').startsWith('livraison')
      );
      this.cdr.detectChanges();
    });
  }

  protected isSingleCartoucheType(typeCapteur: string | null | undefined): boolean {
    const normalized = String(typeCapteur ?? '').trim().toLowerCase();
    return normalized.startsWith('1 cartouche');
  }

  protected getFirstCartoucheLabel(typeCapteur: string | null | undefined): string {
    return this.isSingleCartoucheType(typeCapteur) ? 'Cartouche' : 'Première cartouche';
  }

  protected onNouvelleLigneTypeCapteurChange(): void {
    if (this.isSingleCartoucheType(this.nouvelleLigne.type_capteur)) {
      this.nouvelleLigne.cartouche_b = null;
      this.cartoucheBInput = '';
    }
  }

  protected onLigneTypeCapteurChange(ligne: LigneCommandeEdit): void {
    if (this.isSingleCartoucheType(ligne.type_capteur)) {
      ligne.cartouche_b = null;
      ligne.cartoucheBInput = '';
    }
  }

  protected getStatutLabel(ligne: LigneCommande): string {
    const statutNom = String(ligne.statut_nom ?? '').trim();
    if (statutNom) {
      return statutNom;
    }
    return ligne.statut === 1 ? 'créée' : '-';
  }

  protected isLigneEditable(ligne: LigneCommande): boolean {
    return this.getStatutLabel(ligne).toLowerCase() === 'créée';
  }

  protected canTransferLigne(ligne: LigneCommande): boolean {
    return this.isLigneEditable(ligne);
  }

  protected transferLigne(ligne: LigneCommande): void {
    if (!this.canTransferLigne(ligne)) {
      this.error = "Seules les lignes au statut 'créée' peuvent être transférées.";
      this.cdr.detectChanges();
      return;
    }

    if (!confirm(`Transférer la ligne ${ligne.id} au statut En préparation ?`)) {
      return;
    }

    this.error = '';
    this.ligneSuccess = '';
    this.commandesService.transfererLigne(ligne.id).subscribe({
      next: () => {
        this.editingLigneId = null;
        this.ligneSuccess = 'Ligne transférée en préparation.';
        this.loadLignes();
      },
      error: (err) => {
        this.error = err?.error?.detail || err?.message || 'Erreur lors du transfert de la ligne.';
        this.cdr.detectChanges();
      }
    });
  }

  protected onCartoucheKeypress(): void {
    this.cdr.detectChanges();
  }

  protected isEditingLigne(ligne: LigneCommandeEdit): boolean {
    return this.editingLigneId === ligne.id && this.isLigneEditable(ligne);
  }

  protected startEditLigne(ligne: LigneCommandeEdit): void {
    if (!this.isLigneEditable(ligne)) {
      this.error = "Seules les lignes au statut 'créée' peuvent être modifiées.";
      this.cdr.detectChanges();
      return;
    }
    this.editingLigneId = ligne.id;
    this.error = '';
    this.ligneSuccess = '';
  }

  protected getAdresseLivraisonLabel(adresseId: number | null | undefined): string {
    if (!adresseId) {
      return '';
    }
    const adresse = this.adressesLivraisonClient.find(a => a.id === adresseId);
    if (!adresse) {
      return '';
    }
    return `${adresse.adresse} ${adresse.code_postal} ${adresse.ville}`.trim();
  }

  setCartoucheA(event: any, ligne: any) {
    ligne.cartouche_a = event.option.value;
  }
  setCartoucheB(event: any, ligne: any) {
    ligne.cartouche_b = event.option.value;
  }
  searchCartoucheA(q: string) {
    this.cartoucheAInput = q;
    const needle = q.trim().toLowerCase();
    
    if (needle.length >= 1) {
      // Recherche avec au moins 1 caractère
      const res = this.cartouches.filter(c => String(c.nom ?? '').toLowerCase().includes(needle));
      this.cartoucheAOptions = res;
      if (res.length === 1) {
        this.nouvelleLigne.cartouche_a = res[0].id;
        this.cartoucheAInput = res[0].nom ?? q;
      }
    } else if (needle.length === 0) {
      // Champ vide, afficher les 10 premiers
      this.cartoucheAOptions = this.cartouches.slice(0, 10);
    }
  }

  searchCartoucheB(q: string) {
    this.cartoucheBInput = q;
    const needle = q.trim().toLowerCase();
    
    if (needle.length >= 1) {
      // Recherche avec au moins 1 caractère
      const res = this.cartouches.filter(c => String(c.nom ?? '').toLowerCase().includes(needle));
      this.cartoucheBOptions = res;
      if (res.length === 1) {
        this.nouvelleLigne.cartouche_b = res[0].id;
        this.cartoucheBInput = res[0].nom ?? q;
      }
    } else if (needle.length === 0) {
      // Champ vide, afficher les 10 premiers
      this.cartoucheBOptions = this.cartouches.slice(0, 10);
    }
  }

  loadLignes() {
    this.commandesService.listLignes(this.commandeId).subscribe(lignes => {
      this.lignesCommande = lignes;
      this.setCartoucheInputsOnLignes();
      this.cdr.detectChanges();
    });
  }

  private formatApiError(err: any, fallback: string): string {
    const detail = err?.error?.detail;
    if (typeof detail === 'string' && detail.trim()) {
      return detail;
    }
    if (Array.isArray(detail)) {
      const messages: string[] = [];
      for (const item of detail as Array<{ msg?: unknown; message?: unknown; detail?: unknown }>) {
        const candidates = [item?.msg, item?.message, item?.detail];
        for (const candidate of candidates) {
          if (typeof candidate === 'string' && candidate.trim().length > 0) {
            messages.push(candidate);
            break;
          }
        }
      }
      if (messages.length > 0) {
        return messages.join(' ');
      }
    }
    if (detail && typeof detail === 'object') {
      const message = (detail as any).msg || (detail as any).message || (detail as any).detail;
      if (typeof message === 'string' && message.trim()) {
        return message;
      }
    }
    if (typeof err?.message === 'string' && err.message.trim()) {
      return err.message;
    }
    return fallback;
  }

  private resolveCartoucheIdFromInput(
    input: string | null | undefined,
    currentId: number | string | null | undefined,
    options: Cartouche[]
  ): number | null {
    if (typeof currentId === 'number' && Number.isFinite(currentId)) {
      return currentId;
    }
    if (typeof currentId === 'string') {
      const parsedCurrentId = Number(currentId);
      if (!Number.isNaN(parsedCurrentId) && Number.isFinite(parsedCurrentId)) {
        return parsedCurrentId;
      }
    }

    const needle = String(input ?? '').trim().toLowerCase();
    if (!needle) {
      return null;
    }

    const optionMatch = options.find(c => String(c.nom ?? '').trim().toLowerCase() === needle);
    if (optionMatch) {
      return optionMatch.id;
    }
    const match = this.cartouches.find(c => String(c.nom ?? '').trim().toLowerCase() === needle);
    return match?.id ?? null;
  }

  addLigne() {
    if (!this.nouvelleLigne.adresse_livraison_id) {
      this.error = "Veuillez sélectionner une adresse de livraison avant d'ajouter la ligne de commande.";
      this.cdr.detectChanges();
      return;
    }
    if (!this.nouvelleLigne.type_capteur || !String(this.nouvelleLigne.type_capteur).trim()) {
      this.error = "Veuillez sélectionner un type de capteur avant d'ajouter la ligne de commande.";
      this.cdr.detectChanges();
      return;
    }
    const payload = {
      ...this.nouvelleLigne,
      commande_id: this.commandeId,
      cartouche_b: this.isSingleCartoucheType(this.nouvelleLigne.type_capteur) ? null : this.nouvelleLigne.cartouche_b
    };
    this.commandesService.createLigne(this.commandeId, payload).subscribe({
      next: () => {
        this.nouvelleLigne = { type_capteur: '', adresse_livraison_id: null, cartouche_a: null, cartouche_b: null, date_expedition: '' };
        this.cartoucheAInput = '';
        this.cartoucheBInput = '';
        this.cartoucheAOptions = [];
        this.cartoucheBOptions = [];
        this.error = '';
        this.ligneSuccess = 'Ligne de commande enregistrée';
        this.loadLignes();
      },
      error: (err) => {
        this.ligneSuccess = '';
        this.error = this.formatApiError(err, 'Erreur lors de la création de la ligne.');
        this.cdr.detectChanges();
      }
    });
  }

  onClientChange(clientId: number) {
    this.loadAdressesLivraisonClient(clientId);
  }

  updateLigne(ligne: LigneCommandeEdit) {
    if (!this.isLigneEditable(ligne)) {
      this.error = "Seules les lignes au statut 'créée' peuvent être modifiées.";
      this.cdr.detectChanges();
      return;
    }
    this.ligneSuccess = '';
    if (this.isSingleCartoucheType(ligne.type_capteur)) {
      ligne.cartouche_b = null;
      ligne.cartoucheBInput = '';
    }

    const resolvedCartoucheAId = this.resolveCartoucheIdFromInput(ligne.cartoucheAInput, ligne.cartouche_a, this.cartoucheAOptions);
    const resolvedCartoucheBId = this.isSingleCartoucheType(ligne.type_capteur)
      ? null
      : this.resolveCartoucheIdFromInput(ligne.cartoucheBInput, ligne.cartouche_b, this.cartoucheBOptions);

    if (String(ligne.cartoucheAInput ?? '').trim() && resolvedCartoucheAId === null) {
      this.error = "La cartouche A saisie est invalide. Veuillez sélectionner une valeur proposée.";
      this.cdr.detectChanges();
      return;
    }
    if (!this.isSingleCartoucheType(ligne.type_capteur) && String(ligne.cartoucheBInput ?? '').trim() && resolvedCartoucheBId === null) {
      this.error = "La cartouche B saisie est invalide. Veuillez sélectionner une valeur proposée.";
      this.cdr.detectChanges();
      return;
    }

    ligne.cartouche_a = resolvedCartoucheAId;
    ligne.cartouche_b = resolvedCartoucheBId;

    // On ne garde que les propriétés utiles pour l'API
    const payload = {
      id: ligne.id,
      type_capteur: ligne.type_capteur,
      adresse_livraison_id: ligne.adresse_livraison_id,
      cartouche_a: resolvedCartoucheAId,
      cartouche_b: resolvedCartoucheBId,
      date_expedition: ligne.date_expedition
    };
    this.commandesService.updateLigne(ligne.id, payload).subscribe({
      next: () => {
        this.error = '';
        this.ligneSuccess = 'Ligne de commande enregistrée';
        this.editingLigneId = null;
        this.loadLignes();
      },
      error: (err) => {
        this.ligneSuccess = '';
        this.error = err?.error?.detail || err?.message || 'Erreur lors de la modification de la ligne.';
        this.cdr.detectChanges();
      }
    });
  }

  deleteLigne(id: number) {
    if (!confirm('Supprimer cette ligne ?')) return;
    this.commandesService.deleteLigne(id).subscribe({
      next: () => {
        this.error = '';
        this.loadLignes();
      },
      error: (err) => {
        this.error = err?.error?.detail || err?.message || 'Erreur lors de la suppression de la ligne.';
        this.cdr.detectChanges();
      }
    });
  }

  save() {
    this.saving = true;
    this.commandesService.update(this.commandeId, this.commande).subscribe({
      next: () => {
        this.success = 'Commande mise à jour.';
        this.saving = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.error = err?.error?.detail || err?.message || 'Erreur lors de la mise à jour.';
        this.saving = false;
        this.cdr.detectChanges();
      }
    });
  }

  onCartoucheAInputChange(value: string, ligne: any) {
    if (!value || value.trim() === '') {
      ligne.cartouche_a = null;
      ligne.cartoucheAInput = '';
      // Afficher les 10 premiers quand champ vide
      this.cartouchesService.autocompleteNomDisponibles('').subscribe(res => {
        this.cartoucheAOptions = res;
        this.cdr.detectChanges();
      });
      return;
    }
    this.cartoucheAInput = value;
    const trimmedValue = value.trim();
    if (trimmedValue.length >= 1) {
      // Recherche avec au moins 1 caractère
      this.cartouchesService.autocompleteNomDisponibles(trimmedValue).subscribe(res => {
        this.cartoucheAOptions = res;
        const normalizedValue = trimmedValue.toLowerCase();
        const exact = res.find(c => String(c.nom ?? '').trim().toLowerCase() === normalizedValue);
        if (exact) {
          ligne.cartouche_a = exact.id;
        } else if (res.length === 1) {
          ligne.cartouche_a = res[0].id;
          ligne.cartoucheAInput = res[0].nom ?? value;
        } else {
          ligne.cartouche_a = null;
        }
        this.cdr.detectChanges();
      });
    }
  }

  onCartoucheBInputChange(value: string, ligne: any) {
    if (!value || value.trim() === '') {
      ligne.cartouche_b = null;
      ligne.cartoucheBInput = '';
      // Afficher les 10 premiers quand champ vide
      this.cartoucheBOptions = this.cartouches.slice(0, 10);
      return;
    }
    this.cartoucheBInput = value;
    const trimmedValue = value.trim();
    if (trimmedValue.length >= 1) {
      // Recherche avec au moins 1 caractère
      const needle = trimmedValue.toLowerCase();
      const res = this.cartouches.filter(c => String(c.nom ?? '').toLowerCase().includes(needle));
      this.cartoucheBOptions = res;
      const exact = res.find(c => String(c.nom ?? '').trim().toLowerCase() === needle);
      if (exact) {
        ligne.cartouche_b = exact.id;
      } else if (res.length === 1) {
        ligne.cartouche_b = res[0].id;
        ligne.cartoucheBInput = res[0].nom ?? value;
      } else {
        ligne.cartouche_b = null;
      }
      this.cdr.detectChanges();
    }
  }

  protected getChimieNomById(chimieId: number | string | undefined): string {
    if (chimieId == null) {
      return '';
    }
    const chimieKey = String(chimieId);
    const chimie = this.chimies.find(c => String(c.id) === chimieKey);
    return chimie?.nom ?? '';
  }

  protected getCartoucheOptionLabel(cartouche: Cartouche): string {
    const nom = String(cartouche.nom ?? '').trim();
    const chimieNom = this.getChimieNomById(cartouche.chimie_id);
    if (!chimieNom && cartouche.chimie_id != null) {
      return `${nom} (Chimie ${cartouche.chimie_id})`;
    }
    if (!chimieNom) {
      return nom;
    }
    return `${nom} (${chimieNom})`;
  }

  protected formatDateFr(value: string | null | undefined): string {
    const raw = String(value ?? '').trim();
    if (!raw) {
      return '-';
    }

    const yyyyMmDdMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (yyyyMmDdMatch) {
      const [, y, m, d] = yyyyMmDdMatch;
      return `${d}/${m}/${y}`;
    }

    const parsed = new Date(raw);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed.toLocaleDateString('fr-FR');
    }

    return raw;
  }
}
